{
  "i18n.app.optional": "(optional)",

  "i18n.loadingSpinner.title": "Loading...",

  "i18n.salon.init.error": "Failed to initialize salon",
  "i18n.salon.notReady": "This salon is not ready yet.",

  "i18n.activity.price": "Price",

  "i18n.booking.timezoneNotice": "Slots are in timezone:",
  "i18n.booking.selectService": "Select Service",
  "i18n.booking.selectDateTime": "Select Date/Time slot",
  "i18n.booking.guestDetails": "Guest Details",
  "i18n.booking.reviewAndBook": "Review & Book",
  "i18n.booking.appointmentDetails": "Appointment Details",
  "i18n.booking.date": "Date",
  "i18n.booking.time": "Time",
  "i18n.booking.reviewDescription": "Please review your selection and confirm your booking.",
  "i18n.booking.bookAppointment": "Book Appointment",
  "i18n.booking.confirmation": "Confirmation",
  "i18n.booking.confirmationDescription": "Your booking will be confirmed. You will receive a confirmation email.",
  "i18n.booking.selectSlot": "Select a slot to book an appointment",
  "i18n.booking.noSlotsAvailable": "No slots available",
  "i18n.booking.noServicesAvailable": "No services available",
  "i18n.booking.dateIsInPast": "Date is in the past",
  "i18n.booking.tooFarInAdvance": "This date is not yet available for booking",
  "i18n.booking.email": "Email",
  "i18n.booking.emailPlaceholder": "your.email@example.com",
  "i18n.booking.email.required": "Email is required",
  "i18n.booking.email.emailFormat": "Please enter a valid email address",
  "i18n.booking.email.maxLength": "Email must not exceed 255 characters",
  "i18n.booking.name": "Name",
  "i18n.booking.namePlaceholder": "Your name",
  "i18n.booking.guestName.maxlength": "Name must not exceed 100 characters",
  "i18n.booking.phone": "Phone",
  "i18n.booking.phonePlaceholder": "Your phone number",
  "i18n.booking.guestPhone.maxlength": "Phone number must not exceed 50 characters",
  "i18n.booking.guestPhone.invalid": "Phone number may only contain digits and the characters + - ( ) . / and spaces",
  "i18n.booking.comment": "Note",
  "i18n.booking.commentPlaceholder": "Add any special requests or notes...",
  "i18n.booking.comment.maxlength": "Note must not exceed 500 characters",
  "i18n.booking.appointmentWith": "Appointment with",
  "i18n.booking.updateBooking": "Update Booking",
  "i18n.booking.today": "Today",
  "i18n.booking.datePicker": "Date picker",
  "i18n.booking.previousMonth": "Previous month",
  "i18n.booking.nextMonth": "Next month",

  "i18n.bookingDetails.loadingSpinner.subTitle": "Fetching your data",
  "i18n.bookingDetails.title": "booking details",
  "i18n.bookingDetails.bookingRef": "booking reference",
  "i18n.bookingDetails.guest": "Guest",
  "i18n.bookingDetails.phone": "Phone",
  "i18n.bookingDetails.email": "Email",
  "i18n.bookingDetails.service": "Service",
  "i18n.bookingDetails.date": "Date",
  "i18n.bookingDetails.time": "Time",
  "i18n.bookingDetails.comment": "Notes",

  "i18n.modalConfirmCancel.title": "Cancel Booking",
  "i18n.modalConfirmCancel.subtitle": "Are you sure you want to cancel this booking? This action cannot be undone.",
  "i18n.modalConfirmCancel.confirm": "Yes, Cancel Booking",
  "i18n.modalConfirmCancel.cancel": "Keep Booking",

  "i18n.bookingNotFound.notFound.title": "Booking Not Found",
  "i18n.bookingNotFound.notFound.subtitle": "We could not find this booking. It may have already been cancelled or the link is invalid.",

  "i18n.cancelBooking.title": "Cancel Booking",
  "i18n.cancelBooking.subtitle": "Are you sure you want to cancel this booking?",
  "i18n.cancelBooking.doCancelBooking": "Cancel Booking",
  "i18n.cancelBooking.notCancellable.title": "Cancellation no longer possible",
  "i18n.cancelBooking.notCancellable.subtitle": "The cancellation deadline for this booking has passed. Please contact the salon directly if you need assistance.",
  "i18n.cancelBooking.delete.error": "Failed to cancel the booking. Please try again.",
  "i18n.cancelBooking.delete.tooLate": "This booking can no longer be cancelled.",
  "i18n.cancelBooking.deleted.title": "Booking Cancelled",
  "i18n.cancelBooking.deleted.subtitle": "Your booking has been successfully cancelled.",
  "i18n.cancelBooking.deleted.closePage": "You can safely close this page now.",
  "i18n.booking.notEditable.title": "Booking no longer editable",
  "i18n.booking.notEditable.subtitle": "The edit deadline for this booking has passed. Please contact the salon directly if you need to make changes.",
  "i18n.booking.save.conflict": "This time slot is no longer available. Please select another date-time.",
  "i18n.booking.save.error": "Failed to save the booking. Please try again.",
  "i18n.booking.load.error": "Failed to load booking. Please check the booking reference and try again.",

  "i18n.confirmBooking.title": "Booking Confirmed!",
  "i18n.confirmBooking.subtitle": "Your appointment has been successfully booked. A confirmation email is on its way.",
  "i18n.confirmBooking.addToCalendarIcs": "Add to Calendar (.ics)",
  "i18n.confirmBooking.addToCalendarGoogle": "Calendar Android/Google",
  "i18n.addToCalendar.with": "With",
  "i18n.addToCalendar.guest": "Guest",
  "i18n.addToCalendar.phone": "Phone",
  "i18n.confirmBooking.newBooking": "Book Another Appointment",
  "i18n.confirmBooking.closePage": "You can safely close this page now. Your booking has been saved.",

  "i18n.footer.privacyPolicy": "Privacy Policy",
  "i18n.footer.termsOfService": "Terms of Service",

  "i18n.signUp.legal.1": "I agree to abide by the ",
  "i18n.signUp.legal.2": " and its ",
  "i18n.signUp.legal.3": "",

  "i18n.home.title": "SmallSalon Online Bookings",
  "i18n.home.badge": "Online Booking Platform",
  "i18n.home.headline1": "Book your next",
  "i18n.home.headline2": "salon appointment",
  "i18n.home.headline3": "in seconds.",
  "i18n.home.subheadline": "SmallSalon connects you with independent salons and solo stylists near you. Browse services, pick a time, and confirm - no phone calls needed.",
  "i18n.home.feature1": "Real-time availability - always up to date",
  "i18n.home.feature2": "Instant confirmation with email reminders",
  "i18n.home.feature3": "Reschedule or cancel anytime, hassle-free",
  "i18n.home.cta.website": "Visit SmallSalon.io",
  "i18n.home.cta.register": "Create account",
  "i18n.home.solo.heading": "Are you a solo salon owner?",
  "i18n.home.solo.description": "Get your own booking page. Take online bookings, send automatic reminders, and keep your calendar full - all in one place. Lightweight booking platform for solo entrepreneurs.",
  "i18n.home.solo.cta": "Start for free →",

  "i18n.privacyPolicy.backButton": "← Back",
  "i18n.privacyPolicy.title": "Privacy Policy",
  "i18n.privacyPolicy.effectiveDate": "Effective Date:",
  "i18n.privacyPolicy.effectiveDateValue": "June 1, 2026",
  "i18n.privacyPolicy.intro": "This Privacy Policy explains how Concrete Code GmbH processes personal data in connection with the SmallSalon customer-facing booking application.",

  "i18n.privacyPolicy.s1.title": "1. Controller",
  "i18n.privacyPolicy.s1.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSwitzerland",
  "i18n.privacyPolicy.s1.email": "Email: info@smallsalon.io",

  "i18n.privacyPolicy.s2.title": "2. Scope",
  "i18n.privacyPolicy.s2.p1": "This Privacy Policy applies to customers who use the SmallSalon booking application to view salon information, browse services, and book appointments with independent salon owners.",
  "i18n.privacyPolicy.s2.p2": "The SmallSalon booking application is intended only for users aged 18 or older.",

  "i18n.privacyPolicy.s3.title": "3. Applicable Law",
  "i18n.privacyPolicy.s3.p1": "We process personal data in accordance with Swiss data protection law and, where applicable, the General Data Protection Regulation (GDPR) of the European Union.",

  "i18n.privacyPolicy.s4.title": "4. Role of SmallSalon and Salon Owners",
  "i18n.privacyPolicy.s4.p1": "Salon owners using SmallSalon operate as independent businesses.",
  "i18n.privacyPolicy.s4.p2": "Salon owners are solely responsible for:",
  "i18n.privacyPolicy.s4.li1": "Their services and service quality",
  "i18n.privacyPolicy.s4.li2": "Pricing information",
  "i18n.privacyPolicy.s4.li3": "Schedules and availability",
  "i18n.privacyPolicy.s4.li4": "Booking and cancellation policies",
  "i18n.privacyPolicy.s4.li5": "Their customer relationships",
  "i18n.privacyPolicy.s4.li6": "Their use and processing of customer data within their salon business",
  "i18n.privacyPolicy.s4.p3": "SmallSalon provides the technical infrastructure and platform for appointment booking and communication.",
  "i18n.privacyPolicy.s4.p4": "Salon owners act as independent controllers of customer data related to their own salon operations and customer relationships.",
  "i18n.privacyPolicy.s4.p5": "Customers may need to contact the salon owner directly regarding:",
  "i18n.privacyPolicy.s4.li7": "Appointment-related issues",
  "i18n.privacyPolicy.s4.li8": "Service disputes",
  "i18n.privacyPolicy.s4.li9": "Booking corrections",
  "i18n.privacyPolicy.s4.li10": "Deletion requests related to appointments",

  "i18n.privacyPolicy.s5.title": "5. Personal Data Collected",
  "i18n.privacyPolicy.s5.p1": "When making a booking, the following personal data may be collected:",
  "i18n.privacyPolicy.s5.li1": "Guest name",
  "i18n.privacyPolicy.s5.li2": "Email address",
  "i18n.privacyPolicy.s5.li3": "Booking comments or notes",
  "i18n.privacyPolicy.s5.li4": "Selected service or activity",
  "i18n.privacyPolicy.s5.li5": "Appointment date and time",
  "i18n.privacyPolicy.s5.p2": "Phone numbers are not collected through the SmallSalon booking application.",
  "i18n.privacyPolicy.s5.p3": "Customer email addresses are required in order to send booking-related communications.",
  "i18n.privacyPolicy.s5.p4": "Booking comments are limited to a maximum length of 250 characters.",

  "i18n.privacyPolicy.s6.title": "6. Technical and Security Data",
  "i18n.privacyPolicy.s6.p1": "For technical, operational, and security purposes, we may process:",
  "i18n.privacyPolicy.s6.li1": "IP addresses",
  "i18n.privacyPolicy.s6.li2": "Browser information",
  "i18n.privacyPolicy.s6.li3": "Device information",
  "i18n.privacyPolicy.s6.li4": "Session-related information",
  "i18n.privacyPolicy.s6.li5": "Security and technical logs",
  "i18n.privacyPolicy.s6.p2": "Customers do not create accounts and are not authenticated through the booking application.",

  "i18n.privacyPolicy.s7.title": "7. Booking Communications",
  "i18n.privacyPolicy.s7.p1": "SmallSalon may automatically send:",
  "i18n.privacyPolicy.s7.li1": "Booking confirmation emails",
  "i18n.privacyPolicy.s7.li2": "Appointment reminder emails",
  "i18n.privacyPolicy.s7.li3": "Cancellation notifications",
  "i18n.privacyPolicy.s7.li4": "Rescheduling notifications",
  "i18n.privacyPolicy.s7.p2": "Emails are sent using Amazon Web Services Simple Email Service (AWS SES).",
  "i18n.privacyPolicy.s7.p3": "Delivery of emails and notifications cannot be guaranteed. Emails may be delayed, blocked, filtered, or classified as spam by third-party providers.",

  "i18n.privacyPolicy.s8.title": "8. Cancellation and Rescheduling Policies",
  "i18n.privacyPolicy.s8.p1": "Each salon owner independently defines their own cancellation and modification rules.",
  "i18n.privacyPolicy.s8.p2": "Modification deadlines may apply. After the defined deadline, bookings may become locked and no longer modifiable through the platform.",
  "i18n.privacyPolicy.s8.p3": "Salon owners may independently change their cancellation and modification rules.",

  "i18n.privacyPolicy.s9.title": "9. Payments",
  "i18n.privacyPolicy.s9.p1": "SmallSalon does not process customer payments.",
  "i18n.privacyPolicy.s9.p2": "No payment card or banking information is collected from customers through the SmallSalon booking application.",
  "i18n.privacyPolicy.s9.p3": "Payments for salon services are handled directly between the customer and the salon owner outside the platform.",

  "i18n.privacyPolicy.s10.title": "10. Hosting and Infrastructure",
  "i18n.privacyPolicy.s10.p1": "SmallSalon is hosted on Amazon Web Services (AWS), primarily in the eu-central-1 region.",
  "i18n.privacyPolicy.s10.p2": "The platform uses AWS services including:",
  "i18n.privacyPolicy.s10.li1": "CloudFront",
  "i18n.privacyPolicy.s10.li2": "S3",
  "i18n.privacyPolicy.s10.li3": "Lambda",
  "i18n.privacyPolicy.s10.li4": "DynamoDB",
  "i18n.privacyPolicy.s10.li5": "Cognito",
  "i18n.privacyPolicy.s10.p3": "Backups, technical logs, and security logs may be processed for maintenance, diagnostics, security, fraud prevention, and operational purposes.",

  "i18n.privacyPolicy.s11.title": "11. Cookies",
  "i18n.privacyPolicy.s11.p1": "The booking application may use necessary cookies for:",
  "i18n.privacyPolicy.s11.li1": "Session handling",
  "i18n.privacyPolicy.s11.li2": "Language preferences",
  "i18n.privacyPolicy.s11.li3": "Booking flow functionality",
  "i18n.privacyPolicy.s11.p2": "The SmallSalon booking application currently does not use analytics cookies, advertising trackers, marketing pixels, or similar tracking technologies.",

  "i18n.privacyPolicy.s12.title": "12. Third Parties and Data Sharing",
  "i18n.privacyPolicy.s12.p1": "Personal data may be processed by third-party providers where necessary to operate the platform.",
  "i18n.privacyPolicy.s12.p2": "These providers include:",
  "i18n.privacyPolicy.s12.li1": "Amazon Web Services for hosting, storage, infrastructure, and email delivery",
  "i18n.privacyPolicy.s12.p3": "Booking data is shared with the relevant salon owner for appointment management purposes.",
  "i18n.privacyPolicy.s12.p4": "We do not sell customer personal data.",
  "i18n.privacyPolicy.s12.p5": "Support or administrative staff may access booking-related data where necessary for support, maintenance, troubleshooting, security, fraud prevention, or legal compliance purposes.",

  "i18n.privacyPolicy.s13.title": "13. Data Retention",
  "i18n.privacyPolicy.s13.p1": "Booking-related data may be retained for up to one year.",
  "i18n.privacyPolicy.s13.p2": "Salon owners may independently delete bookings and customer-related booking data.",
  "i18n.privacyPolicy.s13.p3": "If a salon owner deletes their account, associated booking data may also be deleted.",
  "i18n.privacyPolicy.s13.p4": "Backups and certain security or fraud-prevention logs may temporarily remain stored for technical, operational, or legal reasons.",

  "i18n.privacyPolicy.s14.title": "14. Security",
  "i18n.privacyPolicy.s14.p1": "We implement appropriate technical and organizational measures to help protect personal data.",
  "i18n.privacyPolicy.s14.p2": "These measures may include:",
  "i18n.privacyPolicy.s14.li1": "HTTPS and TLS encryption",
  "i18n.privacyPolicy.s14.li2": "Encrypted infrastructure",
  "i18n.privacyPolicy.s14.li3": "Access controls",
  "i18n.privacyPolicy.s14.li4": "Monitoring systems",
  "i18n.privacyPolicy.s14.li5": "Security logging",
  "i18n.privacyPolicy.s14.li6": "Backups",
  "i18n.privacyPolicy.s14.p3": "However, no system can guarantee absolute security.",

  "i18n.privacyPolicy.s15.title": "15. Your Rights",
  "i18n.privacyPolicy.s15.p1": "Subject to applicable law, customers may have rights including:",
  "i18n.privacyPolicy.s15.li1": "Access to personal data",
  "i18n.privacyPolicy.s15.li2": "Correction of inaccurate data",
  "i18n.privacyPolicy.s15.li3": "Deletion of personal data",
  "i18n.privacyPolicy.s15.li4": "Objection to certain processing activities",
  "i18n.privacyPolicy.s15.li5": "Withdrawal of consent where applicable",
  "i18n.privacyPolicy.s15.p2": "Requests may be submitted to: info@smallsalon.io",
  "i18n.privacyPolicy.s15.p3": "SmallSalon may support salon owners technically with customer privacy requests where appropriate.",

  "i18n.privacyPolicy.s16.title": "16. International Data Transfers",
  "i18n.privacyPolicy.s16.p1": "Some service providers may process data outside Switzerland or the European Economic Area.",
  "i18n.privacyPolicy.s16.p2": "Where required, appropriate legal safeguards such as standard contractual clauses or other recognized transfer mechanisms may be used.",

  "i18n.privacyPolicy.s17.title": "17. Updates to This Privacy Policy",
  "i18n.privacyPolicy.s17.p1": "We may update this Privacy Policy from time to time.",
  "i18n.privacyPolicy.s17.p2": "Continued use of the SmallSalon booking application after updates become effective constitutes acceptance of the updated Privacy Policy.",

  "i18n.privacyPolicy.s18.title": "18. Governing Law",
  "i18n.privacyPolicy.s18.p1": "This Privacy Policy is governed by the laws of Switzerland.",

  "i18n.privacyPolicy.s19.title": "19. Contact",
  "i18n.privacyPolicy.s19.p1": "For privacy-related questions or requests, please contact:",
  "i18n.privacyPolicy.s19.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSwitzerland",
  "i18n.privacyPolicy.s19.email": "Email: info@smallsalon.io",

  "i18n.tos.backButton": "← Back",
  "i18n.tos.title": "Booking Terms",
  "i18n.tos.effectiveDate": "Effective Date:",
  "i18n.tos.effectiveDateValue": "June 1, 2026",
  "i18n.tos.intro1": "These Booking Terms (\"Terms\") govern the use of the SmallSalon booking platform by customers booking appointments with independent salon owners.",
  "i18n.tos.intro2": "By making a booking through SmallSalon, you agree to these Terms.",

  "i18n.tos.s1.title": "1. Operator Information",
  "i18n.tos.s1.address": "Concrete Code GmbH\nCH-8304 Wallisellen\nSwitzerland",
  "i18n.tos.s1.contact": "Contact: info@smallsalon.io",

  "i18n.tos.s2.title": "2. Purpose of the Platform",
  "i18n.tos.s2.p1": "SmallSalon allows customers to book appointments with independent salon owners.",
  "i18n.tos.s2.p2": "Customers may book appointments without creating a customer account.",
  "i18n.tos.s2.p3": "SmallSalon provides the technical platform used for appointment booking and communication.",
  "i18n.tos.s2.p4": "SmallSalon does not guarantee appointment availability.",

  "i18n.tos.s3.title": "3. Relationship Between Customers and Salon Owners",
  "i18n.tos.s3.p1": "The booking agreement exists exclusively between the customer and the salon owner.",
  "i18n.tos.s3.p2": "SmallSalon and Concrete Code GmbH:",
  "i18n.tos.s3.p2list": "- are not salons\n- do not employ salon owners\n- do not supervise salon owners\n- are not responsible for salon services",
  "i18n.tos.s3.p3": "Salon owners are fully and solely responsible for:",
  "i18n.tos.s3.p3list": "- service descriptions\n- pricing information\n- schedules and availability\n- uploaded images and content\n- service quality\n- appointment fulfillment\n- cancellations and rescheduling\n- hygiene standards\n- legal and regulatory compliance",
  "i18n.tos.s3.p4": "Concrete Code GmbH and SmallSalon are not responsible for inaccurate, misleading, outdated, incomplete, or unlawful information uploaded or provided by salon owners.",

  "i18n.tos.s4.title": "4. Payments",
  "i18n.tos.s4.p1": "SmallSalon does not process payments between customers and salon owners.",
  "i18n.tos.s4.p2": "Payments for salon services are handled directly between the customer and the salon owner, typically onsite at the salon.",
  "i18n.tos.s4.p3": "Concrete Code GmbH and SmallSalon are not responsible for:",
  "i18n.tos.s4.p3list": "- payment disputes\n- refunds\n- pricing disagreements\n- failed or disputed transactions between customers and salons",

  "i18n.tos.s5.title": "5. Booking Rules and Cancellation Policies",
  "i18n.tos.s5.p1": "Salon owners may cancel or reschedule appointments at their discretion.",
  "i18n.tos.s5.p2": "Customers may cancel or modify appointments subject to the salon's individual cancellation policy.",
  "i18n.tos.s5.p3": "Each salon defines its own booking modification deadline, which determines how far in advance customers may cancel or modify appointments.",
  "i18n.tos.s5.p4": "Modification deadlines typically range between 0 and 48 hours before the scheduled appointment time.",
  "i18n.tos.s5.p5": "Once the modification deadline has passed, bookings may become locked and no longer modifiable through the platform.",
  "i18n.tos.s5.p6": "Customers are responsible for reviewing the cancellation and modification policy of their chosen salon before booking.",
  "i18n.tos.s5.p7": "Salon owners may update their cancellation policies at any time, with changes applying to future booking modifications.",
  "i18n.tos.s5.p8": "Missed appointments and no-shows are solely the responsibility of the customer and the salon owner.",

  "i18n.tos.s6.title": "6. Customer Responsibilities",
  "i18n.tos.s6.p1": "Customers agree to provide accurate and complete booking information.",
  "i18n.tos.s6.p2": "Fraudulent, abusive, misleading, fake, or spam bookings are strictly prohibited.",
  "i18n.tos.s6.p3": "Customers are responsible for ensuring that their contact details are correct and reachable.",
  "i18n.tos.s6.p4": "Concrete Code GmbH and SmallSalon reserve the right to block or restrict access to users who misuse the platform.",

  "i18n.tos.s7.title": "7. Notifications and Communication",
  "i18n.tos.s7.p1": "SmallSalon may send booking confirmations, reminders, cancellation notices, and other operational communications related to appointments.",
  "i18n.tos.s7.p2": "Concrete Code GmbH and SmallSalon are not responsible for failed, delayed, filtered, blocked, or undelivered notifications, including emails that are classified as spam or otherwise not received.",

  "i18n.tos.s8.title": "8. Platform Availability",
  "i18n.tos.s8.p1": "SmallSalon is provided on an \"as-is\" and \"as-available\" basis.",
  "i18n.tos.s8.p2": "Concrete Code GmbH does not guarantee uninterrupted availability of the platform.",
  "i18n.tos.s8.p3": "The platform may occasionally become unavailable due to maintenance, updates, technical issues, or external factors.",
  "i18n.tos.s8.p4": "Concrete Code GmbH reserves the right to modify, suspend, or discontinue features or parts of the platform at any time.",

  "i18n.tos.s9.title": "9. Privacy and Customer Data",
  "i18n.tos.s9.p1": "Booking-related customer data is shared with the salon owner for appointment management purposes.",
  "i18n.tos.s9.p2": "After booking, salon owners may independently process customer data according to their own privacy practices and legal obligations.",
  "i18n.tos.s9.p3": "Salon owners are separately responsible for their own compliance with applicable privacy and data protection laws.",
  "i18n.tos.s9.p4": "Use of the platform is also governed by the Privacy Policy.",

  "i18n.tos.s10.title": "10. Intellectual Property",
  "i18n.tos.s10.p1": "The SmallSalon platform, software, branding, design, and related intellectual property are owned by Concrete Code GmbH.",
  "i18n.tos.s10.p2": "Customers may not:",
  "i18n.tos.s10.p2list": "- copy or reproduce the platform\n- reverse engineer the platform\n- abuse or misuse the platform\n- attempt unauthorized access to systems or data",

  "i18n.tos.s11.title": "11. Disclaimer of Liability",
  "i18n.tos.s11.p1": "To the maximum extent permitted by law, Concrete Code GmbH and SmallSalon are not liable for:",
  "i18n.tos.s11.p1list": "- salon services or service quality\n- injuries or allergic reactions\n- dissatisfaction with salon services\n- missed appointments\n- inaccurate pricing\n- inaccurate service descriptions\n- customer disputes\n- lost or damaged property\n- business interruptions\n- decisions or actions of salon owners",
  "i18n.tos.s11.p2": "Use of the platform is at your own risk.",

  "i18n.tos.s12.title": "12. Force Majeure",
  "i18n.tos.s12.p1": "Concrete Code GmbH shall not be liable for delays, interruptions, or failures caused by circumstances beyond reasonable control, including but not limited to natural disasters, internet outages, cyberattacks, power failures, governmental actions, wars, labor disputes, or failures of third-party service providers.",

  "i18n.tos.s13.title": "13. Independent Salon Businesses",
  "i18n.tos.s13.p1": "All salons using SmallSalon operate as independent businesses.",
  "i18n.tos.s13.p2": "Individual salons may maintain their own policies, cancellation rules, pricing structures, and operating procedures.",
  "i18n.tos.s13.p3": "Customers should review salon-specific information carefully before making a booking.",

  "i18n.tos.s14.title": "14. Changes to These Terms",
  "i18n.tos.s14.p1": "Concrete Code GmbH may update or modify these Terms from time to time.",
  "i18n.tos.s14.p2": "Continued use of the platform after updated Terms become effective constitutes acceptance of the revised Terms.",

  "i18n.tos.s15.title": "15. Severability",
  "i18n.tos.s15.p1": "If any provision of these Terms is found invalid or unenforceable, the remaining provisions shall remain fully valid and enforceable.",

  "i18n.tos.s16.title": "16. Governing Law",
  "i18n.tos.s16.p1": "These Terms are governed by the laws of Switzerland.",
  "i18n.tos.s16.p2": "Any disputes arising from the use of SmallSalon shall be subject to the jurisdiction of the competent courts of Switzerland.",

  "i18n.tos.s17.title": "17. Contact",
  "i18n.tos.s17.p1": "For legal, privacy, or platform-related questions, you may contact:",
  "i18n.tos.s17.contact": "Concrete Code GmbH\ninfo@smallsalon.io"
}
